<template>
  <sticky-header-layout>
    <template #header>
      <div class="action-container">
        <div class="search-container">
          <el-input
            v-model="title"
            class="search-input"
            placeholder="Title"
            prefix-icon="el-icon-search"
            size="mini"
            clearable
          />
          <el-input
            v-model="slug"
            class="search-input"
            placeholder="Slug"
            prefix-icon="el-icon-search"
            size="mini"
            clearable
          />
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-search"
            circle
            @click="filterTitleSlug"
          />
        </div>
        <div class="pagination-container">
          <el-pagination
            :disabled="isLoading"
            :current-page="listQuery.page"
            :page-sizes="listQuery.sizes"
            :page-size="listQuery.size"
            :total="listQuery.total"
            background
            layout="total, sizes, pager, jumper"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"/>
        </div>
        <div class="button-container">
          <el-button
            :disabled="isLoading"
            circle
            icon="el-icon-refresh"
            @click="getList"/>
          <el-button
            class="add-button"
            type="primary"
            icon="el-icon-edit"
            @click="handleCreate">{{ $t('button.create') }}</el-button>
        </div>
      </div>
    </template>

    <el-table
      v-loading="isLoading"
      :data="list"
      border
      stripe
      style="width: 100%"
    >
      <el-table-column
        prop="id"
        label="ID"
        width="50"
      />
      <el-table-column
        prop="title"
        label="Title"
        min-width="150"
      />
      <el-table-column
        prop="facebook_title"
        label="Facebook Title"
        min-width="200"
      />
      <el-table-column
        prop="facebook_image"
        label="Facebook Image"
        width="160"
      >
        <template slot-scope="scope">
          <img :src="scope.row.facebook_image" width="150"/>
        </template>
      </el-table-column>
      
      <el-table-column
        prop="category.title"
        label="Category"
        width="90"
      />
      <el-table-column
        label="Created At"
        width="100"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span style="margin-left:5px;">{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Enable"
        width="60"
      >
        <template slot-scope="scope">
          <div class="status-row">
            <el-switch
              v-model="scope.row.enabled"
              :disabled="scope.row.isLoading"
              @change="handleEditorialEnabledChange(scope.row)"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="List"
        width="60"
      >
        <template slot-scope="scope">
          <div class="status-row">
            <el-switch
              v-model="scope.row.listed"
              :disabled="scope.row.isLoading"
              @change="handleEditorialListedChange(scope.row)"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="Actions"
        align="center"
        width="190"
      >
        <template #default="scope">
          <div class="button-group">
            <el-dropdown @command="openPreviewLink">
              <el-button
                icon="el-icon-view"
                circle
              />
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{locale: 'hk/en', token: scope.row.preview_token}">
                  Preview EN <font-awesome-icon icon="external-link-alt" />
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="scope.row.location === 2"
                  :command="{locale: 'hk/zh', token: scope.row.preview_token}"
                >
                  Preview HK <font-awesome-icon icon="external-link-alt" />
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="scope.row.location === 2"
                  :command="{locale: 'hk/cn', token: scope.row.preview_token}"
                >
                  Preview CN <font-awesome-icon icon="external-link-alt" />
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="scope.row.location === 1"
                  :command="{locale: 'th', token: scope.row.preview_token}"
                >
                  Preview TH <font-awesome-icon icon="external-link-alt" />
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-button
              :disabled="!scope.row.has_newhope_contents"
              size="mini"
              type="warning"
              icon="el-icon-edit"
              circle
              @click="handleUpdate(scope.row)"
            />

            <el-button
              :disabled="!scope.row.has_newhope_contents"
              size="mini"
              type="info"
              icon="el-icon-document"
              circle
              @click="handleView(scope.row)"
            />

            <el-button
              :disabled="!scope.row.has_newhope_contents"
              size="mini"
              round
              @click="handleDuplicate(scope.row)"
            >Copy</el-button>
            <!-- <el-button size="mini" type="danger" icon="el-icon-delete" circle
            @click="handleDeletion(scope.row)"></el-button> -->
          </div>
        </template>
      </el-table-column>
    </el-table>
  </sticky-header-layout>
</template>

<script>
import useTablePaging from '../../mixins/useTablePaging'
import EditorialsService from '../../api/editorials'

export default {
  name: 'EditorialList',
  mixins: [useTablePaging],
  created() {
    this.getList()
  },
  data() {
    return {
      title: '',
      slug: '',
    }
  },
  methods: {
    async getList() {
      this.isLoading = true
      try {
        const response = await EditorialsService.getList(this.listQuery.page, this.listQuery.size, this.title, this.slug)
        const { data: newList, pagination } = response
        this.list = []
        for (let i = 0; i < newList.length; i += 1) {
          const item = newList[i]
          item.isLoading = false
          item.enabled = !!+item.enabled // convert 1,0 to boolean so can use v-model
          item.listed = !!+item.listed // convert 1,0 to boolean so can use v-model
          this.list.push(item)
        }
        this.listQuery.total = parseInt(pagination.total_items, 0)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
    async deleteItem() {
      try {
        this.$message({
          message: 'Item deleted',
          type: 'success',
        })
      } catch (error) {
        this.$message({
          message: 'Could not delete item. Please try again.',
          type: 'error',
        })
      }
    },
    async toggleEditorial(editorialItem, isEnabled) {
      editorialItem.isLoading = true
      try {
        await EditorialsService.toggleEnableEditorial(editorialItem.id, isEnabled)
        editorialItem.isLoading = false
      } catch (error) {
        // Roll back
        editorialItem.enabled = !isEnabled
        editorialItem.isLoading = false
      }
    },
    async toggleEditorialList(editorialItem, isListed) {
      editorialItem.isLoading = true
      try {
        await EditorialsService.toggleListEditorial(editorialItem.id, isListed)
        editorialItem.isLoading = false
      } catch (error) {
        // Roll back
        editorialItem.listed = !isListed
        editorialItem.isLoading = false
      }
    },
    async duplicateEditorial(row) {
      try {
        await EditorialsService.duplicateEditorial(row.id)
        this.getList()
      } catch (error) {
        // Handle later
      }
    },
    handleDuplicate(row) {
      const editorialId = row.id
      this.$confirm(`This will duplicate the editorial with ID: "${editorialId}". Continue?`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        this.duplicateEditorial(row)
      }).catch(() => {
      })
    },
    handleDeletion(row) {
      const editorialId = row.id
      this.$confirm(`This will permanently delete the editorial with ID: "${editorialId}". Continue?`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        this.deleteItem(row)
      }).catch(() => {
      })
    },
    handleEditorialEnabledChange(editorial) {
      if (editorial.enabled) {
        this.toggleEditorial(editorial, true)
        return
      }

      this.$confirm('Are you sure you want to disable this editorial?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        // Update server
        this.toggleEditorial(editorial, false)
      }).catch(() => {
        editorial.enabled = true
      })
    },
    handleEditorialListedChange(editorial) {
      this.$confirm('Are you sure you want to update the list of this editorial?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        // Update server
        this.toggleEditorialList(editorial, editorial.listed)
      }).catch(() => {
        editorial.listed = !editorial.listed
      })
    },
    handleCreate() {
      this.$router.push({ path: '/editorial/create' })
    },
    handleUpdate(row) {
      this.$router.push({ path: `/editorial/edit/${row.id}` })
    },
    handleView(row) {
      this.$router.push({ path: `/editorial/view/${row.id}` })
    },
    openPreviewLink({ locale, token }) {
      const goxipLink = locale === 'th' ? process.env.VUE_APP_GOXIP_TH_BASE_URL : process.env.VUE_APP_GOXIP_BASE_URL
      const previewLink = `${goxipLink}/${locale}/editorial/preview/${token}`
      window.open(previewLink, '_blank')
    },
    getLocationString(locationId) {
      switch (locationId) {
        case 1:
          return 'EN TH'
        case 2:
          return 'EN HK CN'
        default:
          return 'Unknown'
      }
    },
    filterTitleSlug() {
      this.getList()
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";

section {
  .status-row {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .el-dropdown {
    margin-right: 8px;
  }
}

.search-container {
  display:flex;
  .search-input {
    width: 200px;
    margin-right: 10px;
  }
  button {
    margin: 0 5px;
  }
}

.cell {
  overflow: visible;
}
</style>
